var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBarsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18L20 18",
    stroke: "#1c1b1f",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "#1c1b1f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12L20 12",
    stroke: "#1c1b1f",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "#1c1b1f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6L20 6",
    stroke: "#1c1b1f",
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: "#1c1b1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBarsBlack);
export default __webpack_public_path__ + "static/media/filter-bars-black.fa564e93a0b47c392534f2c268c9a409.svg";
export { ForwardRef as ReactComponent };